import { render } from "./dynamicView.component.vue?vue&type=template&id=27329da1"
import script from "./dynamicView.component.vue?vue&type=script&lang=js"
export * from "./dynamicView.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/periple/dynamicView.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27329da1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27329da1', __exports__)) {
    console.log('reload')
    api.reload('27329da1', __exports__)
  }
  
  module.hot.accept("./dynamicView.component.vue?vue&type=template&id=27329da1", () => {
    console.log('re-render')
    api.rerender('27329da1', render)
  })

}


export default __exports__